
// send cart info to marketing cloud
$(document).ready(() => {
    $('body').on('sfmcAbandonedCartTrack', (e, data) => {
        if (data && data.items) {
            let cartItems = data.items.map(item => ({
                unique_id: item.id,
                item: item.id,
                quantity: item.quantity,
                price: item.price.sales.decimalPrice,
            }));
            if (cartItems.length) {
                console.log(cartItems.length);
                _etmc.push(['trackCart', { cart: JSON.stringify(cartItems) }]);
            } else {
                console.log(cartItems.length);
                _etmc.push(['trackCart', { clear_cart: true }]);
            }
        }
    });
});
